/**
 * Created by doujiajun on 2018/8/15.
 */
import Common from '../../config/common'
class Goods {
  static getList(options = {}) {
    return Common.ajax.get('/webservice/pms/goodsList', {params: options})
  }

  // static getDetail(productSku) {
  //   return Common.ajax.get('erp/api/pms/goods/' + productSku)
  // }
    static getDetail(productSku) {
        return Common.ajax.get('/webservice/pms/goods/detail/' + productSku)
    }
    static getSimpleDetail(productSku, fingerprint) {
        return Common.ajax.get('/webservice/pms/goods/detail/' + productSku, {
            params: {simple: 'Y'},
            headers: {'X-Simple-Fingerprint': fingerprint}
        })
    }
    static verifySimpleChallenge(payload, fingerprint) {
        return Common.ajax.post('/webservice/pms/guard/challenge/verify', payload, {
            headers: {'X-Simple-Fingerprint': fingerprint}
        })
    }
    static getBrand() {
        return Common.ajax.get('/webservice/pms/brand')
    }


}

export default Goods;



// WEBPACK FOOTER //
// ./src/models/goods/goods.js